import type { MutableRefObject } from "react";
import { useEffect, useRef } from "react";

import { StyledAddedItemIndicator } from "./styles";

export type ListIndicator = { appear(): void };

type AddedItemIndicatorProps = {
    position: "top" | "bottom";
    listIndicatorRef: MutableRefObject<ListIndicator | null>;
};

export const AddedItemIndicator = ({ position, listIndicatorRef }: AddedItemIndicatorProps) => {
    const indicatorElementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const appear = () => {
            indicatorElementRef.current?.getAnimations().forEach((animation) => animation.cancel());
            indicatorElementRef.current?.animate(
                { opacity: [0, 1, 1, 0], offset: [0, 0.2, 0.8, 1], easing: "ease-in-out" },
                1500,
            );
        };

        listIndicatorRef.current = { appear };
    }, [listIndicatorRef]);

    return (
        <StyledAddedItemIndicator
            position={position}
            ref={indicatorElementRef}
        />
    );
};
